import { render } from "./LegendSeats.vue?vue&type=template&id=9749d3ec&scoped=true"
import script from "./LegendSeats.vue?vue&type=script&lang=js"
export * from "./LegendSeats.vue?vue&type=script&lang=js"

import "./LegendSeats.vue?vue&type=style&index=0&id=9749d3ec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9749d3ec"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QDialog,QCard,QCardSection,QSpace});qInstall(script, 'directives', {ClosePopup});
